import React from 'react';
import { useLaptop } from 'hooks';

import { AlertCustom } from 'components/AlertCustom/AlertCustom';
import { useTranslation } from 'next-i18next';

interface AlertDefaultCartProps {
  isNeedAlert?: boolean;
  phoneNumber?: string | null;
}

export const AlertDefaultCart = ({ isNeedAlert }: AlertDefaultCartProps) => {
  const { isOverLaptop } = useLaptop();
  const { t } = useTranslation();

  return isNeedAlert ? (
    <AlertCustom type={'error'} mb={isOverLaptop ? '24px' : '16px'}>
      <span>
        {t`app.cart.limits_exceeded`}. {t`app.cart.please`}&nbsp;
        {t`verify`}
      </span>
    </AlertCustom>
  ) : null;
};
